import {
  DashboardIcon,
  BenefitsIcon,
  EmployeesIcon,
  SettingsIcon
} from "../assets/Icons";

const admin = [
  {
    path: "/",
    title: "Dashboard",
    icon: DashboardIcon
  },
  {
    path: "/providers",
    title: "Providers",
    icon: BenefitsIcon
  },
  {
    path: "/activity",
    title: "Activity",
    icon: BenefitsIcon
  },
  {
    path: "/companies",
    title: "Companies",
    icon: BenefitsIcon
  },
  {
    path: "/users",
    title: "Users",
    icon: EmployeesIcon
  },
  {
    path: "/settings",
    title: "Settings",
    icon: SettingsIcon
  },
  {
    path: "/notifications",
    title: "Notifications",
    icon: DashboardIcon
  }
];

const hr = [
  {
    path: "/",
    title: "Dashboard",
    icon: DashboardIcon
  },
  {
    path: "/benefits",
    title: "Benefits",
    icon: BenefitsIcon
  },
  {
    path: "/company-benefits",
    title: "Company Benefits",
    icon: BenefitsIcon
  },
  {
    path: "/employees",
    title: "Employees",
    icon: EmployeesIcon
  },
  {
    path: "/settings",
    title: "Settings",
    icon: SettingsIcon
  }
];

export const navLogos = {
  Dashboard: DashboardIcon,
  Benefits: BenefitsIcon,
  Providers: BenefitsIcon,
  Activity: BenefitsIcon,
  Companies: BenefitsIcon,
  Users: EmployeesIcon,
  Settings: SettingsIcon,
  Notifications: DashboardIcon,
  "Company Benefits": BenefitsIcon,
  Employees: EmployeesIcon,
  Refunds: EmployeesIcon
};

export const navigationConfig = {
  admin: admin,
  hr: hr
};
